"use strict";
'use client';
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFixIosKeyboardScrollBug = void 0;
var react_1 = require("react");
var useFixIosKeyboardScrollBug = function () {
    (0, react_1.useEffect)(function () {
        var resetScroll = function () {
            var html = document.documentElement;
            html.style.height = '100%';
            document.body.style.height = '100%';
            html.style.overflow = 'hidden';
            document.body.style.overflow = 'hidden';
            html.style.overscrollBehavior = 'none';
            document.body.style.overscrollBehavior = 'none';
            html.style.touchAction = 'none';
            document.body.style.touchAction = 'none';
        };
        if (typeof window !== 'undefined') {
            if (window.visualViewport) {
                window.visualViewport.addEventListener('resize', resetScroll);
            }
        }
        return function () {
            if (typeof window !== 'undefined') {
                if (window.visualViewport) {
                    window.visualViewport.removeEventListener('resize', resetScroll);
                }
            }
        };
    }, []);
};
exports.useFixIosKeyboardScrollBug = useFixIosKeyboardScrollBug;
